import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('delivery_status')
@doc.path('/delivery_statuses/{?id}')
export default class DeliveryStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_DeliveryStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_DeliveryStatusReference;

	public get color() {
		switch (this.reference) {
			case 'to_prepare':
				return 'black';
			case 'prepared':
				return 'pink';
			case 'to_ship':
				return 'blue';
			case 'shipped':
				return 'purple';
			case 'delivered':
				return 'green';
			case 'waiting':
				return 'orange';
			case 'canceled':
				return 'red';
		}
	}
}
